










































































































































/**
 * External dependencies.
 */
import { Component, Vue, Watch } from 'vue-property-decorator'
import VueScrollTo from 'vue-scrollto'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

/**
 * Internal dependencies.
 */
import { lazyInject } from '@/container'
import { TYPES } from '@/types'
import CyclingAds from '@/components/ui/CyclingAds.vue'
import UploadDropzone from '@/components/account/UploadDropzone.vue'
import UploadDialog from '@/components/account/UploadDialog.vue'

@Component({
  components: {
    UploadDropzone,
    UploadDialog,
    CyclingAds,
    VueGoogleAutocomplete
  }
})
export default class AccountSettings extends Vue {
  @lazyInject(TYPES.PhotoService)
  PhotoService: any

  @lazyInject(TYPES.AuthService)
  AuthService: any

  @lazyInject(TYPES.AdService)
  AdService: any

  @lazyInject(TYPES.DynamicTextService)
  DynamicTextService: any

  credits: any = null
  adsForSlides: Array<any> = []
  currentDropzoneComponent: any = UploadDropzone
  isFirefox: boolean = false
  isHover: any = null
  submitDisabled: boolean = true // allow on Dropzone condition
  // category data may be structured differently later
  categories: any = []
  selectedCategoryId: number | string = 0
  selectedCategoryName: string = ''
  // update openCategoryClassification to something else later
  openCategoryClassification: string = ''
  dropzoneReset: boolean = false
  TermsText: string = ''
  adsEl: any | HTMLInputElement

  user: any = null
  uploadedFile: any = null
  uploadLoader: boolean = false
  uploadSuccess: boolean = false
  uploadError: any = null
  locationData: {} | any = {}
  locationError: boolean = false
  paresedLocation: object | any = {
    city: '',
    state: '',
    country: ''
  }

  created () {
    this.user = this.AuthService.getAuthUser()
    this.credits = this.user.credits

    this.AdService.getAds({ location: 'uploading' })
      .then((response: any) => {
        this.adsForSlides = response.data
      })

    this.PhotoService.getContests()
      .then((response: any) => {
        this.categories = response.data
        if (response.meta.user && response.meta.user.credits) {
          this.credits = response.meta.user.credits
        }
      })

    this.DynamicTextService.getSetting('general', 'terms-of-service')
      .then((response: any) => {
        this.TermsText = response
      })
      .catch((error: any) => {
        console.error('Error fetching setting from database: ', error)
      })
  }

  getLocationData (addressData: object, placeResultData: object, id: string) {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     */
    this.locationData = addressData

    this.paresedLocation.city = this.locationData.locality
    this.paresedLocation.state = this.locationData.administrative_area_level_1
    this.paresedLocation.country = this.locationData.country

    if (this.paresedLocation.city === '' || this.paresedLocation.state === '' || this.paresedLocation.country === '') {
      this.locationError = true
      console.log('error with location parsing', this.paresedLocation)
    } else {
      this.locationError = false
    }
  }

  setPhoto (file: any, dataUrl: any) {
    this.submitDisabled = false

    // remove for resize on component swap
    // this.adsEl = document.querySelector('#ads')
    // this.adsEl.removeAttribute('id')

    setTimeout(() => {
      this.currentDropzoneComponent = UploadDialog
      this.uploadedFile = file
      console.log('uploadFile after setting: ', this.uploadedFile)
    }, 100)
  }

  resetUpload (success: boolean = false) {
    this.uploadLoader = false
    this.submitDisabled = true
    this.selectedCategoryId = 0
    this.selectedCategoryName = success ? this.selectedCategoryName : ''
    this.uploadedFile = null
    this.uploadError = null
    this.uploadSuccess = success
    this.currentDropzoneComponent = UploadDropzone
  }

  categorySelection (id: number | string, name: string, className: string) {
    this.selectedCategoryId = id
    this.selectedCategoryName = name
    this.submitDisabled = true
    this.currentDropzoneComponent = UploadDialog // UploadDropzone
    this.uploadLoader = true

    // this.adsEl = document.querySelector('.ads')
    // this.adsEl.setAttribute('class', 'ads-after')

    let scrollOptions = {
      easing: 'ease-in',
      offset: -60,
      force: true,
      cancelable: true,
      x: false,
      y: true
    }
    VueScrollTo.scrollTo('#contest-submissions', 700, scrollOptions)
    console.log('id ', this.selectedCategoryId, 'name ', this.selectedCategoryName)
    console.log('set photo details: ', this.uploadedFile)

    const base64 = this.uploadedFile.dataUrl

    fetch(base64)
      .then(res => res.blob())
      .then(blob => {
        const fd = new FormData()
        const file = new File([blob], this.uploadedFile.name, { type: this.uploadedFile.type })
        fd.append('image', this.uploadedFile, this.uploadedFile.name)
        fd.append('contest_id', String(this.selectedCategoryId))
        fd.append('city', this.paresedLocation.city)
        fd.append('state', this.paresedLocation.state)
        fd.append('country', this.paresedLocation.country)
        fd.append('location', JSON.stringify({
          city: this.paresedLocation.city,
          state: this.paresedLocation.state,
          country: this.paresedLocation.country
        }))

        this.PhotoService.uploadPhoto(this.user.id, fd)
          .then((response: any) => {
            console.log('upload response', response)
            const { success, data, errors, meta: { user = {} } } = response
            this.uploadLoader = false

            if (success) {
              this.resetUpload(true)
              if (user && user.credits) {
                this.credits = user.credits
              }
            } else {
              this.uploadError = errors
            }
          })
      })
      .catch((error: any) => {
        console.log(`blob conversion error: ${error}`)
      })
  }
}
